<template>
  <div data-luko-tracking="Page-Partners">
    <PartnersModule :data="document" />
  </div>
</template>

<script>
import PartnersModule from '~/modules/Partners'
import { formatMetaDatas } from '~/utils/metaData'

export default {
  head() {
    return formatMetaDatas(this.metaDatas)
  },

  components: {
    PartnersModule,
  },

  async asyncData({ $prismic, app, store, error }) {
    try {
      const { data: document, alternate_languages } = await $prismic.api.getSingle('partners', {
        lang: app.i18n.localeProperties.prismicIso,
      })
      store.dispatch('setAlternateLanguages', alternate_languages)
      // Force to set theme for navbar and footer
      store.commit('page/UPDATE', { primary: { theme: '2021Q4-pink' } })

      return {
        document,
        metaDatas: document.body1 || [],
      }
    } catch (e) {
      console.error(e)
      error({ statusCode: 500, message: 'Error in asyncData' })
    }
  },
}
</script>
